import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import formatDate from '../../../../frontend/components/components/utils/formatDate';
import BigNumber from '../../../../frontend/components/components/utils/numbers/BigNumber';
import Percent from '../../../../frontend/components/components/utils/numbers/Percent';
import Price from '../../../../frontend/components/components/utils/numbers/Price';
import TendenceTable from '../../../influencer/pages/Analytics/components/TendenceTable'
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';
import store from '../../../../javascript/store';

const Posts = ({
  data,
  averageEmv = false,
  avgPlaysOverViewToFollower = false,
  averageShares = false,
  averageViews = false,
  averageComments = false,
  averageViews60 = false,
  likesPerView = false,
  commentsPerView = false,
  averageEngRate = false,
  lastVideoPosted = false,
  engagementRate = false,
  mostUsedHashtags = false,
  customTitle = '',
  colSm = null,
  useCustomDateFormat = false,
  totalVideos = false,
  averageLikes = false,
  viewToFollowerRatio = false,
}) => {
  const { t } = useTranslation();
  if (!data) return;

  const showMostUsedHashtags = mostUsedHashtags && Object.keys(get(data, 'stats.hash_tags') || {}).length;
  const customDateFormat = () => {
    const user = get(store.getState(), 'auth.user');
    if (!useCustomDateFormat) return {};

    return {
      format: (user && get(user, 'european') ? 'DD.MM.YYYY' : 'MM.DD.YYYY')
    };
  }

  return (<React.Fragment>
    <h4 className='mb-4'>
      {!isEmpty(customTitle) ? customTitle : t('common.pages.analytics.posts')}
    </h4>
    <Row className='mb-6'>
      {
        totalVideos &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.total_videos') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.total_videos')}
          </div>
        </Col>
      }
      {
        averageViews &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.avg_views') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.average_views')}
          </div>
        </Col>
      }
      {
        averageEmv &&
        <Col xs={12} sm={colSm || 4}>
          <h3><Price number={get(data, 'stats.avg_emv') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.average_emv')}
          </div>
        </Col>
      }
      {/* DISABLED UNTIL ENG-8730 COMPLETED */}
      {/* {
        avgPlaysOverViewToFollower &&
        <Col xs={12} sm={colSm || 4}>
          <h3><Price number={get(data, 'stats.avg_plays_over_view_to_follower') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.avg_plays_over_view_to_follower')}
          </div>
        </Col>
      } */}
      {
        averageShares &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.avg_shares') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.average_shares')}
          </div>
        </Col>
      }
      {
        averageComments &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.avg_comments') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.average_comments')}
          </div>
        </Col>
      }
      {
        averageLikes &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.avg_likes') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.average_likes')}
          </div>
        </Col>
      }
      {
        viewToFollowerRatio && 
        <Col xs={12} sm={colSm || 4}>
          <h3><Percent number={get(data, 'stats.view_to_follower_ratio') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.view_to_follower_ratio')}
          </div>
        </Col>
      }
      {
        averageViews60 &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.sixty_day_view_average') || get(data, 'stats.sixty_day_avg_views') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.average_60_views')}
          </div>
        </Col>
      }
      {
        likesPerView &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.likes_to_views_ratio') || get(data, 'stats.likes_per_view') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.likes_per_view')}
          </div>
        </Col>
      }
      {
        commentsPerView &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.comments_to_views_ratio') || get(data, 'stats.comments_per_view') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.comments_per_view')}
          </div>
        </Col>
      }
      {
        averageEngRate &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.comments_to_views_ratio') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.avg_eng_rate')}
          </div>
        </Col>
      }
      {
        engagementRate &&
        <Col xs={12} sm={colSm || 4}>
          <h3><BigNumber number={get(data, 'stats.engagement_rate') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.avg_eng_rate')}
          </div>
        </Col>
      }
      {
        lastVideoPosted &&
        <Col xs={12} sm={colSm || 4}>
          <h3>{formatDate(get(data, 'stats.last_video_posted_at') || null, customDateFormat())} </h3>
          <div className="mb-3">
            {t('common.pages.analytics.last_video_posted')}
          </div>
        </Col>
      }

    </Row>

    {
      showMostUsedHashtags && <React.Fragment>
        <h4 className='mb-5'>
          {t('common.pages.analytics.most_used_hashtags')}
        </h4>

        <div className="mb-6">
          <TendenceTable data={get(data, 'stats.hash_tags', {})} />
        </div>
      </React.Fragment>
    }
  </React.Fragment >);
};

Posts.propTypes = {
  data: PropTypes.any.isRequired,
  averageEmv: PropTypes.bool,
  averageShares: PropTypes.bool,
  averageViews: PropTypes.bool,
  averageComments: PropTypes.bool,
  averageViews60: PropTypes.bool,
  likesPerView: PropTypes.bool,
  commentsPerView: PropTypes.bool,
  averageEngRate: PropTypes.bool,
  lastVideoPosted: PropTypes.bool,
  mostUsedHashtags: PropTypes.bool,
  totalVideos: PropTypes.bool,
  averageLikes: PropTypes.bool,
  viewsToFollower: PropTypes.bool,
};

Posts.defaultProps = {
  averageEmv: false,
  averageShares: false,
  averageViews: false,
  averageComments: false,
  averageViews60: false,
  likesPerView: false,
  commentsPerView: false,
  averageEngRate: false,
  lastVideoPosted: false,
  mostUsedHashtags: false,
  totalVideos: false,
  averageLikes: false,
  viewsToFollower: false,
};

export default React.memo(Posts);
